import { defineStore } from 'pinia'
import { nameInitial } from '@/utils/text'
import { getPortalBootstrap } from '@/api/portal'

let bootstrapPromise = null

function emptyBootstrap() {
  return {
    site: {
      name: '',
      url: '',
      icon: '',
      logo: '',
      description: '',
      keywords: []
    },
    filing: {
      icp: '',
      gongan: ''
    },
    contact: {
      wechat: '',
      email: ''
    },
    author: {
      nickname: '',
      avatar: ''
    },
    pageDescriptions: {
      articles: '',
      notes: '',
      archives: '',
      links: '',
      about: ''
    }
  }
}

function normalizeBootstrap(payload = {}) {
  const fallback = emptyBootstrap()
  return {
    site: {
      ...fallback.site,
      ...(payload.site || {}),
      keywords: Array.isArray(payload.site?.keywords) ? payload.site.keywords : []
    },
    filing: {
      ...fallback.filing,
      ...(payload.filing || {})
    },
    contact: {
      ...fallback.contact,
      ...(payload.contact || {})
    },
    author: {
      ...fallback.author,
      ...(payload.author || {})
    },
    pageDescriptions: {
      ...fallback.pageDescriptions,
      ...(payload.pageDescriptions || {})
    }
  }
}

export const useAppStore = defineStore('app', {
  state: () => ({
    bootstrap: emptyBootstrap(),
    bootstrapLoading: false,
    bootstrapReady: false,
    bootstrapError: ''
  }),
  getters: {
    site: (state) => state.bootstrap.site,
    filing: (state) => state.bootstrap.filing,
    contact: (state) => state.bootstrap.contact,
    author: (state) => state.bootstrap.author,
    pageDescriptions: (state) => state.bootstrap.pageDescriptions,
    siteName: (state) => state.bootstrap.site.name,
    brandMark: (state) => nameInitial(state.bootstrap.site.name),
    bootstrapFailed(state) {
      return !state.bootstrapReady && !state.bootstrapLoading && !!state.bootstrapError
    }
  },
  actions: {
    async initialize({ force = false } = {}) {
      if (this.bootstrapReady && !force) {
        return this.bootstrap
      }
      if (bootstrapPromise) {
        return bootstrapPromise
      }

      this.bootstrapLoading = true
      this.bootstrapError = ''
      bootstrapPromise = getPortalBootstrap()
        .then((payload) => {
          this.bootstrap = normalizeBootstrap(payload)
          this.bootstrapReady = true
          return this.bootstrap
        })
        .catch((error) => {
          this.bootstrapError = error?.message || '站点信息加载失败'
          throw error
        })
        .finally(() => {
          this.bootstrapLoading = false
          bootstrapPromise = null
        })
      return bootstrapPromise
    },
    async refreshBootstrap() {
      return this.initialize({ force: true })
    }
  }
})
